<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HubSpot',
  
  data() {
    return {
      hubspotMounted: false,
    }
  },
  
  computed: {
    ...mapGetters({
      isHubspotOpen: 'app/getIsHubspotModalOpen',
    }),

    shouldDisplayHubspotForm() {
      return this.isHubspotOpen;
    }
  },
  
  created() {
    this.mountHubspotForm();
  },
  
  methods: {
    mountHubspotForm() {
      if (this.hubspotMounted) return;
      
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '22181133',
          formId: '4b0fe21a-8026-406b-9670-b9e021cea553',
          region: 'na1',
          target: '#hubspot-form',
        });
        this.hubspotMounted = true;
        return;
      }
      
      const script = document.createElement('script');
      script.src = '//js.hsforms.net/forms/embed/v2.js';
      script.async = true;
      script.onload = () => {
        window.hbspt.forms.create({
          portalId: '22181133',
          formId: '4b0fe21a-8026-406b-9670-b9e021cea553',
          region: 'na1',
          target: '#hubspot-form',
        });
        this.hubspotMounted = true;
      };
      document.body.appendChild(script);
    },
    
    handleCloseModal() {
      this.$store.commit('app/SET_HUBSPOT_MODAL_OPEN', false);
    }
  }
};
</script>

<template>
  <transition name="fade">
    <div class="hubspot-modal" :class="{active: shouldDisplayHubspotForm}" v-show="shouldDisplayHubspotForm">
      <div class="hubspot-modal__background" @click="handleCloseModal"/>
        <div class="hubspot-modal__form" id="hubspot-form"></div>
    </div>
  </transition>
</template>

<style scoped lang="scss">
.hubspot-modal {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  overflow: hidden;
}

.hubspot-modal__background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
}

.hubspot-modal__form {
  position: relative;
  z-index: 1001;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 700px;
  max-height: 50vh;
  overflow-y: auto;
}

@media screen and (max-width: 768px) {
  .hubspot-modal__form {
    width: 90%;
    padding: 10px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

</style>